module.exports = __webpack_public_path__ + "static/assets/5c462658fc40281443c326ed63de0532.svg";